// Адрес API берётся из переменной сборки REACT_APP_APIGW_BASE_URL (frontend/.env).
// Если её не передали, боевая сборка ходит в API своего же сайта (/api) —
// раньше фолбэком был localhost:8000, и сборка без переменной ломала прод.
// Адрес абсолютный: в коде есть new URL(endpoint), относительный он не примет.
const API_BASE =
  process.env.REACT_APP_APIGW_BASE_URL ||
  (process.env.NODE_ENV === "production"
    ? `${window.location.origin}/api`
    : "http://localhost:8000");

const configs = {
  BASE_URL: API_BASE,
  BASE_URL_AUTO: API_BASE,
  // Семантическая версия фронта. Поднимать вручную при релизе.
  // Можно переопределить через REACT_APP_VERSION при сборке.
  FRONTEND_VERSION: process.env.REACT_APP_VERSION || "0.9.33",
};

export default configs;
